export const convertBuiltCampaignComponentResponseToBuiltComponentResponse = (parameters) => {
    return {
        id: parameters.builtCampaignComponent.id,
        campaign_id: parameters.campaignId,
        source_client_id: parameters.sourceClientId,
        campaign_state: parameters.campaignState,
        upload_version: parameters.builtCampaignComponent.upload_version,
        name: parameters.builtCampaignComponent.name,
        display_name: parameters.builtCampaignComponent.display_name,
        type: parameters.builtCampaignComponent.type,
        description: parameters.builtCampaignComponent.description,
        tags: parameters.builtCampaignComponent.tags,
        variables: parameters.builtCampaignComponent.variables,
        assets: parameters.builtCampaignComponent.assets,
        component_ids: parameters.builtCampaignComponent.component_ids,
        created_date: parameters.builtCampaignComponent.created_date,
        updated_date: parameters.builtCampaignComponent.updated_date,
        absolute_names: parameters.builtCampaignComponent.absolute_names,
        installed_into_socket: parameters.builtCampaignComponent.installed_into_socket,
        facets: parameters.builtCampaignComponent.facets,
    };
};
